export default function (data = {}, storeState) {
    data.locale = storeState.locale;
    data.fallbackLocales = storeState.fallbackLocales;
    data.guestCountry = storeState.guestCountry;
    data.guestCurrency = storeState.guestCurrency;

    data.timezone = typeof Intl === 'object' && Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    data.isDeviceMobile = storeState.isDeviceMobile;

    if (storeState.requestIP) {
        data.ipaddress = storeState.requestIP;
        data.ipAddress = storeState.requestIP;
    }

    if (storeState.requestUserAgent) {
        data.userAgent = storeState.requestUserAgent;
    }

    if (storeState.user) {
        data.sessionKey = storeState.user.sessionKey;
        data.partyId = storeState.user.partyId;
        data.userCurrency = storeState.user.currency;
        data.userCurrencyHtmlCode = storeState.user.currencyHtmlCode;
        data.userCountry = storeState.user.country;
        data.userLanguageCode = storeState.user.language;
        data.userEmail = storeState.user.email;
        data.userId = storeState.user.id;
        data.username = storeState.user.username;
        data.userRegistrationStatus = storeState.user.registrationStatus;
    } else {
        data.guestToken = storeState.guestToken;
    }

    return data;
}